/**
 * Проверяет является ли переданное значение массивом.
 *
 * @param value Значение, которое нужно проверить.
 * @returns true, если переданное значение является массивом, иначе false.
 * @example
 * ```typescript
 * import { isArray } from '@direct-frontend/stdlib';
 *
 * isArray([1, 2, 3]); // true
 * isArray(null); // false
 * isArray('string'); // false
 * ```
 */
export function isArray(value) {
    return Array.isArray(value);
}
